document.addEventListener('DOMContentLoaded', function () {
  var revealEls = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
    revealEls.forEach(function (el) { observer.observe(el); });
    setTimeout(function () {
      revealEls.forEach(function (el) { el.classList.add('is-visible'); });
    }, 1200);
  } else {
    revealEls.forEach(function (el) { el.classList.add('is-visible'); });
  }

  var header = document.querySelector('.site-header');
  if (header) {
    var onScroll = function () {
      if (window.scrollY > 8) {
        header.classList.add('is-scrolled');
      } else {
        header.classList.remove('is-scrolled');
      }
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  var stickyBar = document.getElementById('StickyAtc'); var mainAtcBtn = document.getElementById('MainAddToCart'); if (stickyBar && mainAtcBtn && 'IntersectionObserver' in window) { var atcObserver = new IntersectionObserver(function (entries) { entries.forEach(function (entry) { if (entry.isIntersecting) { stickyBar.classList.remove('is-visible'); } else if (entry.boundingClientRect.top < 0) { stickyBar.classList.add('is-visible'); } }); }, { threshold: 0 }); atcObserver.observe(mainAtcBtn); } else if (stickyBar) { stickyBar.classList.add('is-visible'); }
  var siteHeaderEl = document.querySelector('.site-header');
  function setStickyOffset(){
    if (siteHeaderEl) {
      document.documentElement.style.setProperty('--header-h', siteHeaderEl.offsetHeight + 'px');
    }
  }
  setStickyOffset();
  window.addEventListener('resize', setStickyOffset);

  var stickyBtn = document.getElementById('StickyAtcButton');
  var mainForm = document.getElementById('main-product-form');
  if (stickyBtn && mainForm) {
    stickyBtn.addEventListener('click', function () {
      if (mainForm.requestSubmit) {
        mainForm.requestSubmit();
      } else {
        mainForm.submit();
      }
    });
  }
});


// Hero slideshow
(function () {
  var slides = document.querySelectorAll('.hero-slide');
  if (slides.length < 2) return;
  var current = 0;
  setInterval(function () {
    slides[current].classList.remove('is-active');
    current = (current + 1) % slides.length;
    slides[current].classList.add('is-active');
  }, 6000);
})();


/* ---- RIYRO playful interactions ---- */
(function () {
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var isFinePointer = window.matchMedia && window.matchMedia('(pointer: fine)').matches;

  function spawnStar(x, y, size, duration) {
    var star = document.createElement('span');
    star.className = 'riyro-star-particle';
    star.textContent = '✦';
    star.style.left = x + 'px';
    star.style.top = y + 'px';
    star.style.fontSize = size + 'px';
    star.style.setProperty('--dx', (Math.random() * 40 - 20) + 'px');
    star.style.setProperty('--dur', duration + 's');
    document.body.appendChild(star);
    setTimeout(function () { star.remove(); }, duration * 1000 + 50);
  }

  if (!reduceMotion && isFinePointer) {
    var lastSpawn = 0;
    document.addEventListener('mousemove', function (e) {
      var now = Date.now();
      if (now - lastSpawn < 70) return;
      lastSpawn = now;
      spawnStar(e.clientX, e.clientY, 9 + Math.random() * 7, 0.55);
    });
  }

  function spawnBurstStar(cx, cy, dx, dy) {
    var star = document.createElement('span');
    star.className = 'riyro-burst-star';
    star.textContent = Math.random() > 0.5 ? '✦' : '★';
    star.style.left = cx + 'px';
    star.style.top = cy + 'px';
    star.style.setProperty('--dx', dx + 'px');
    star.style.setProperty('--dy', dy + 'px');
    document.body.appendChild(star);
    setTimeout(function () { star.remove(); }, 750);
  }

  var form = document.getElementById('main-product-form');
  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = document.getElementById('MainAddToCart');
      var originalText = btn.textContent;
      var rect = btn.getBoundingClientRect();
      var cx = rect.left + rect.width / 2;
      var cy = rect.top + rect.height / 2;

      fetch('/cart/add.js', {
        method: 'POST',
        body: new FormData(form),
        headers: { 'Accept': 'application/json' }
      }).then(function (res) {
        if (!res.ok) { throw new Error('add failed'); }
        return res.json();
      }).then(function () {
        if (!reduceMotion) {
          for (var i = 0; i < 14; i++) {
            (function (i) {
              setTimeout(function () {
                var angle = Math.random() * Math.PI * 2;
                var dist = 30 + Math.random() * 50;
                spawnBurstStar(cx, cy, Math.cos(angle) * dist, Math.sin(angle) * dist);
              }, i * 15);
            })(i);
          }
        }
        btn.textContent = btn.dataset.addedText || 'Eklendi ✓';
        btn.classList.add('is-added');
        setTimeout(function () {
          btn.textContent = originalText;
          btn.classList.remove('is-added');
        }, 1800);
        return fetch('/cart.js').then(function (r) { return r.json(); });
      }).then(function (cart) {
        var link = document.querySelector('.cart-link');
        if (link && cart) {
          link.textContent = (link.dataset.label || 'Sepet') + ' (' + cart.item_count + ')';
          link.classList.add('bump');
          setTimeout(function () { link.classList.remove('bump'); }, 500);
        }
      }).catch(function () {
        form.submit();
      });
    });
  }

  console.log('%c✦ RIYRO', 'font-size:18px;font-weight:700;color:#b6371f;', '\nHer desen elle cizilir, sinirli sayida uretilir.\nMerakiniz icin tesekkurler.');
})();
